import React, { Component } from 'react';
import { graphql, Link } from 'gatsby';

import Layout from '../components/layout';
import ModelHeaderCard from '../components/model-header-card';
import ModelCard from '../components/model-card';

import classes from './make.module.css';

class MakePage extends Component {
  state = {
    ...this.props.data.dataJson
  };

  componentDidMount() {}

  render() {
    return (
      <Layout>
        <div className={classes.MakeContainer} style={{ padding: '0 10px' }}>
          <div
            style={{
              display: 'flex',
              justifyContent: 'center',
              paddingTop: 8,
              marginBottom: 24
            }}
          >
            <Link to="/">
              <span
                style={{ color: '#008f79', fontWeight: 'bold', fontSize: 17 }}
              >
                Back to all makes
              </span>
            </Link>
          </div>

          <ModelHeaderCard data={this.state} />

          {this.state.models.map(model => (
            <ModelCard data={model} key={model.id} />
          ))}
        </div>
      </Layout>
    );
  }
}

export default MakePage;

export const query = graphql`
  query($slug: String!) {
    dataJson(slug: { eq: $slug }) {
      make
      slug
      links {
        id
        link
      }
      linkDate
      agent
      showrooms {
        id
        street
        postcode
        tel
      }
      models {
        id
        make
        model
        submodel
        ves_category
        ves_rebate
        subsidies
        list_price
        nett_price
      }
    }
  }
`;
